module.exports = __webpack_public_path__ + "static/img/137_TO8_1834_og.d8e84dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/137_TO8_1834_og.jpg
// module id = ydTy
// module chunks = 0